import { useState, useEffect, useRef } from "react";
import { X } from "@phosphor-icons/react";

const INTRO_VIDEO_URL = "https://customer-assets.emergentagent.com/job_agent-studio-105/artifacts/u5icazfo_VIDEO%20HEMSIDAN.mp4";
const SESSION_KEY = "senzum_intro_seen";

// Decide exactly once per page load (survives React StrictMode's double-mount in dev).
let _decided = false;
let _shouldShow = false;
function decideIntro() {
  if (_decided) return _shouldShow;
  _decided = true;
  try {
    if (!sessionStorage.getItem(SESSION_KEY)) {
      sessionStorage.setItem(SESSION_KEY, "1");
      _shouldShow = true;
    }
  } catch {
    /* sessionStorage unavailable — skip intro */
  }
  return _shouldShow;
}

export const IntroVideo = () => {
  const [show, setShow] = useState(decideIntro);
  const [leaving, setLeaving] = useState(false);
  const videoRef = useRef(null);

  const dismiss = () => {
    setLeaving(true);
    setTimeout(() => setShow(false), 600);
  };

  useEffect(() => {
    if (!show) return;
    // Safety net: never block the site for more than 25s even if the video stalls.
    const t = setTimeout(dismiss, 25000);
    return () => clearTimeout(t);
  }, [show]);

  if (!show) return null;

  return (
    <div
      data-testid="intro-video-overlay"
      className={`fixed inset-0 z-[100] bg-black flex items-center justify-center transition-opacity duration-500 ${leaving ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      <video
        ref={videoRef}
        src={INTRO_VIDEO_URL}
        autoPlay
        muted
        playsInline
        preload="auto"
        onEnded={dismiss}
        onError={dismiss}
        className="w-full h-full object-contain"
      />
      <button
        data-testid="intro-skip-button"
        onClick={dismiss}
        className="absolute top-5 right-5 inline-flex items-center gap-1.5 rounded-full bg-white/15 hover:bg-white/30 backdrop-blur text-white text-sm font-semibold px-4 py-2 transition-colors"
      >
        Hoppa över <X size={16} weight="bold" />
      </button>
    </div>
  );
};
